export const addShipmentVisitEndpoint = (shipmentUid: string) => `/shipments/${shipmentUid}/visits`
